import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type VoiceMemoIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const VoiceMemoIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: VoiceMemoIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Voice memo'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5 17L10.5 2M15 13L15 6M6 11.5L6 7.5'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  )
}
